import { Table, Text } from '@quintoandar-tokko/jopijs';
import styles from '../dashboardTables.module.scss';
import TrendChip from '../../TrendChip';
import getArrowIcon from '../../utils/getArrowIcon';
import AgentBranchCell from '../components/AgentBranchCell';

export default function ResponseTimeTableRowMulti({ row }) {
  const {
    id,
    agent,
    average_response_time,
    assigned_contacts,
    responded_contacts,
    unattended_reassigned_contacts,
    variation,
    percentage_status,
    branch,
  } = row;

  return (
    <Table.RowDefault id={id} variant="secondary">
      <Table.RowItemDefault
        variant="secondary"
        className={styles.tableBodyCell}
      >
        <AgentBranchCell
          agentId={agent?.id}
          agentName={agent?.name}
          branchName={branch?.name}
          image={agent?.profile_picture}
          relativeSelector="#response-time-modal"
          withImage
          withBranch
          withBoldTitle
          modal="responseTime"
        />
      </Table.RowItemDefault>

      <Table.RowItemDefault
        variant="secondary"
        className={styles.tableBodyCell}
      >
        <Text variant="body.fontSize13">{average_response_time}</Text>
        <TrendChip
          text={variation}
          percentageStatus={percentage_status}
          icon={getArrowIcon(percentage_status, false)}
        />
      </Table.RowItemDefault>

      <Table.RowItemDefault
        variant="secondary"
        className={styles.tableBodyCell}
      >
        <Text className={styles.textToRight} variant="body.fontSize13">
          {assigned_contacts}
        </Text>
      </Table.RowItemDefault>

      <Table.RowItemDefault
        variant="secondary"
        className={styles.tableBodyCell}
      >
        <Text className={styles.textToRight} variant="body.fontSize13">
          {responded_contacts}
        </Text>
      </Table.RowItemDefault>

      <Table.RowItemDefault
        variant="secondary"
        className={styles.tableBodyCell}
      >
        <Text className={styles.textToRight} variant="body.fontSize13">
          {unattended_reassigned_contacts}
        </Text>
      </Table.RowItemDefault>
    </Table.RowDefault>
  );
}
